import React from "react";

import { Search } from "lucide-react";

import { Input } from "@needl-ai/common/components/ui/input";

const SearchInput = ({ value, onChange }: SearchInputProps) => {
  return (
    <div className="relative mt-4">
      <Search
        size={16}
        className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 dark:text-gray-400"
      />
      <Input
        type="text"
        placeholder="Search your history..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`w-full pl-9 pr-4 py-2.5 rounded-lg transition-colors`}
        data-testid="search-history-input"
      />
    </div>
  );
};

type SearchInputProps = {
  value: string;
  onChange: (value: string) => void;
};

export default SearchInput;
